import styled, { css } from 'styled-components';

const ProgressBarWrapper = styled.div`
  background-color: var(--color-accent-primary-weaker);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  flex-direction: row;
  height: 8px;
  width: 100%;
`;

const LineArea = styled.div`
  animation: progressBar 1.5s ease-in-out;
  animation-fill-mode: forwards;
  background-color: var(--color-accent-primary-default);
  border-radius: inherit;
  height: 100%;
  text-align: right;

  @keyframes progressBar {
    0% {
      width: 0;
    }
    ${({ completedPercent = 100 }) => css`
      100% {
        width: ${completedPercent}%;
      }
    `}
  }
`;

export { LineArea, ProgressBarWrapper };
